  <!-- Modal pour mes cours -->
<div *ngIf="modalName == 'buttonsearch'" >
  <div class="modal fade" id="CoursModal" role="dialog" style="opacity: 100; top: 40%;">
    <div class="modal-dialog" >
    
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Mon Cours</h4>
          <button type="button" class="close" data-dismiss="modal" style="text-align:center">&times;</button>
        </div>
        <div class="modal-body" >
         <p>Cours : {{info[0]}}</p>
         <p>Filiares : {{info[1]}}</p>
         <p>Semestre : {{info[2]}}</p>
         <p>Enseignant : {{info[3]}}</p>
         <p>Site Web de l'enseignant : <a>{{info[4]}}</a></p>
         <p>Type : {{info[5]}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Close</button>
        </div>
      </div>
      
    </div>
  </div>
</div>

<!-- Modal pour mes doc -->
<div *ngIf="modalName == 'searchDoc'">
    <div (click)="disp()" class="modal fade" id="DocModal" role="dialog" style="opacity: 100; top: 40%;">
      <div class="modal-dialog">
      
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Mon Documents</h4>
            <button type="button" class="close" data-dismiss="modal" style="text-align:center">&times;</button>
          </div>
          <div class="modal-body" >
           <p>Nom : {{info[0]}}</p>
           <p>Date : {{info[1]}}</p>
           <p>Type : {{info[2]}}</p>
           
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Close</button>
          </div>
        </div>
        
      </div>
    </div>
</div>

<div *ngIf="modalName == 'searchMail'">
    <div class="modal fade" id="MailModal" role="dialog" style="opacity: 100; top: 40%;">
      <div class="modal-dialog">
      
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Mon Mail</h4>
            <button type="button" class="close" data-dismiss="modal" style="text-align:center">&times;</button>
          </div>
          <div class="modal-body" >
           <p>de : {{info[0]}}</p>
           <p>a : {{info[1]}}</p>
           <p>cc : {{info[2]}}</p>
           <p>Objet : {{info[3]}}</p>
           <p>Message : <a>{{info[4]}}</a></p>
           <p>Pieces : {{info[5]}}</p>
           <p>Date : {{info[6]}}</p>
           <p>Heure  : {{info[7]}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Close</button>
          </div>
        </div>
        
      </div>
    </div>
</div>
  
<div *ngIf="modalName == 'simpleEmprunt'">
    <div (click)="disp()" class="modal fade" id="EmpruntModal" role="dialog" style="opacity: 100; top: 40%;">
      <div class="modal-dialog">
      
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Fiche Emprunt</h4>
            <button type="button" class="close" data-dismiss="modal" style="text-align:center">&times;</button>
          </div>
          <div class="modal-body" >
           <p>titre : {{info[0]}}</p>
           <p>Auteur : {{info[1]}}</p>
           <p>Date d'emprunt : {{info[2]}}</p>
           <p>Date de fin d'emprunt : {{info[3]}}</p>
           
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Close</button>
          </div>
        </div>
        
      </div>
    </div>
</div>

<div *ngIf="modalName == 'simpleContact'">
    <div (click)="disp()" class="modal fade" id="ContactModal" role="dialog" style="opacity: 100; top: 40%;">
      <div class="modal-dialog">
      
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Fiche contact</h4>
            <button type="button" class="close" data-dismiss="modal" style="text-align:center">&times;</button>
          </div>
          <div class="modal-body" >
           <p>Nom : {{info[0]}}</p>
           <p>Prénom : {{info[1]}}</p>
           <p>telephone : {{info[2]}}</p>
           <p>mail : {{info[3]}}</p>
           <p>Bureau : {{info[4]}}</p>
           
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Close</button>
          </div>
        </div>
        
      </div>
    </div>
</div> 

<div *ngIf="modalName == 'datesearch'">
    <div (click)="disp()" class="modal fade" id="EDTModal" role="dialog" style="opacity: 100; top: 40%;">
      <div class="modal-dialog">
      
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Fiche Cours EDT</h4>
            <button type="button" class="close" data-dismiss="modal" style="text-align:center">&times;</button>
          </div>
          <div class="modal-body" >
            <p>Cours : {{info[0]}}</p>
            <p>Filiares : {{info[1]}}</p>
            <p>Semestre : {{info[2]}}</p>
            <p>Enseignant : {{info[3]}}</p>
            <p>Site Web de l'enseignant : <a>{{info[4]}}</a></p>
            <p>Type : {{info[5]}}</p>
            <p>Date : {{info[6]}}</p>
            <p>Heure de debut : {{info[7]}}</p>
            <p>Heure de fin : {{info[8]}}</p>
            <p>Présentiel : {{info[9]}}</p>
            <p>Salle : {{info[10]}}</p>
            <p>Zoom : <a>{{info[11]}}</a></p>
           </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Close</button>
          </div>
        </div>
        
      </div>
    </div>
</div>